<template>
  <div class="taktarea-card grey darken-3">
    <slot name="dialog" />
    <div class="taktarea-card-header">
      <slot name="header" />
    </div>
    <div class="taktarea-card-body">
      <slot name="body" />
    </div>
  </div>
</template>
<script>

  export default {
    props: []
  }
</script>
<style>
.taktarea-card {
  position: absolute;
  border-radius: 10px;
  height: 100%;
  width: 100%;
  z-index: 100;
  top: 0px;
  left: 0px;
}

.taktarea-card-header {
  height: 50px;
}

.taktarea-card-body {
  overflow-y: scroll;
  height: calc(100% - 50px);
  position: relative;
  padding: 5px;
}

</style>
